<template>
  <v-card flat>
    <v-card-title class="text-h6">{{title}}</v-card-title>
    <v-divider/>
    <div style="height:calc(100vh - 166px)" class="pt-2 overflow-y">
      <v-form v-model="valid" ref="form" :disabled="action==='Edit' && completed">
        <v-container>
          <v-row v-if="action === 'Add'">
            <v-col class="text-center mb-4">
              <v-btn-toggle v-model="type" color="primary" mandatory
                            @change="input.quantity=0;$nextTick(() => $refs.form.validate())">
                <v-btn value="action" small>Action</v-btn>
                <v-btn value="adhoc" small>Ad-hoc</v-btn>
                <v-btn value="sub" small v-if="!input.parentId">Group</v-btn>
                <v-btn value="template" small v-if="templates.length && !input.template">Template</v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>

          <template v-if="type==='template'">
            <v-row>
              <v-col>
                <v-select label="Template" :items="templates" outlined dense item-text="description" item-value="id" v-model="templateId"
                          @change="input.description=selectedTemplate.description" :rules="[fieldRules.required]">
                  <template v-slot:item="{item}">
                    <v-list-item-content>{{item.description}}</v-list-item-content>
                    <v-list-item-action class="text-caption">
                      <template v-if="item.hasSubActivities">Group</template>
                      <template v-else-if="item.primitiveId">Action</template>
                      <template v-else>Ad-hoc</template>
                    </v-list-item-action>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-text-field label="Description" outlined dense v-model="input.description" :rules="[fieldRules.required,fieldRules.maxLength(100)]" counter="100"/>
              </v-col>
            </v-row>
            <v-row dense v-if="selectedTemplate && selectedTemplate.primitiveId && sites.length>1">
              <v-col>
                <v-select label="Site" outlined dense v-model="input.siteId"
                          :items="sites" item-text="name" item-value="id"/>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="5">
                <date-picker v-if="!input.parentId" v-model="input.startDate" label="Start" dateOnly @change="refreshDependencies"/>
                <decimal-number-input v-else v-model="input.offsetDays" label="Offset from parent start" prefix="" suffix="days" :precision="0" @change="refreshDependencies"/>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-select v-model="input.dependsOn" label="Depends on" :items="dependencies" item-text="description" item-value="id"
                          outlined dense multiple no-data-text="No possible previous activities found"/>
              </v-col>
            </v-row>
          </template>

          <template v-else>

            <v-row v-if="type==='action'" dense>
              <v-col cols="8">
                <multi-level-select :menuData="primitivesMenu" :second.sync="input.primitiveId" label="Action"
                                    outlined :disabled="input.hasSubActivities"
                                    @change="changePrimitive()"/>
              </v-col>
              <v-col v-if="quantityLabel" cols="4">
                <decimal-number-input v-model="input.quantity" :label="quantityLabel" prefix="" :suffix="quantitySuffix" :precision="quantityPrecision" :disabled="!input.primitiveId" @change="setPrimitiveMaterials();setDuration()"/>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col>
                <v-text-field label="Description" outlined dense v-model="input.description" :rules="[fieldRules.required,fieldRules.maxLength(100)]" counter="100"/>
              </v-col>
            </v-row>

            <v-row dense v-if="type==='action' && sites.length>1 && !toTemplate">
              <v-col>
                <v-select label="Site" outlined dense v-model="input.siteId"
                          :items="sites" item-text="name" item-value="id"/>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="5" v-if="!toTemplate || input.parentId">
                <date-picker v-if="!input.parentId" v-model="input.startDate" label="Start" dateOnly @change="refreshDependencies"/>
                <decimal-number-input v-else v-model="input.offsetDays" label="Offset from parent start" prefix="" suffix="days" :precision="0" @change="refreshDependencies"/>
              </v-col>
              <v-col v-if="type!=='sub'" cols="7">
                <duration-picker  v-model="input.duration" label="Duration" dense use-days :disabled="input.hasSubActivities"/>
              </v-col>
            </v-row>

            <v-row v-if="type!=='sub'" dense>
              <v-col>
                <v-select v-model="input.roleId" label="Performed by role" :items="roles" item-text="name" item-value="id"
                          outlined dense @change="input.roleId ? assignTo.splice(0,assignTo.length) : ''">
                  <template v-slot:prepend-item>
                    <div class="pa-2 grey lighten-3 text-body-2 font-weight-medium cursor-pointer" @click="createRole=true">
                      <v-icon color="primary" class="mr-2">mdi-plus-thick</v-icon>Add new role
                    </div>
                  </template>
                </v-select>
              </v-col>
            </v-row>

            <v-row v-if="type!=='sub'" dense>
              <v-col>
                <outlined-block title="Assign to">
                  <v-simple-table width="100%" class="mt-1">
                    <thead>
                      <tr>
                        <th width="10%" class="pa-0 text-center">
                          <v-btn fab color="primary" x-small @click="addAssignTo()" :disabled="users().length===0 || completed"><v-icon>mdi-plus</v-icon></v-btn>
                        </th>
                        <th width="90%"/>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(user,index) in assignTo" :key="index">
                        <td width="10%" class="pa-0 text-center">
                          <v-icon @click="assignTo.splice(index,1)" :disabled="completed">mdi-delete</v-icon>
                        </td>
                        <td width="90%">
                          <v-select :items="users(user.id)" item-value="userId" item-text="name" :rules="[fieldRules.required]" v-model="user.id"/>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </outlined-block>
              </v-col>
            </v-row>

            <v-row dense v-if="!toTemplate || input.parentId">
              <v-col>
                <v-select v-model="input.dependsOn" label="Depends on" :items="dependencies" item-text="description" item-value="id"
                          outlined dense multiple no-data-text="No possible previous activities found"/>
              </v-col>
            </v-row>

            <v-row v-if="type!=='sub'" dense>
              <v-col>
                <outlined-block title="Equipment required">
                  <v-simple-table width="100%" class="mt-1">
                    <thead>
                      <tr>
                        <th width="10%" class="pa-0 text-center">
                          <v-btn fab color="primary" x-small @click="addEquipment()" :disabled="equipment().length===0 || completed"><v-icon>mdi-plus</v-icon></v-btn>
                        </th>
                        <th width="90%"/>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(e,index) in equipmentUsed" :key="e.key">
                        <td width="10%" class="pa-0 text-center">
                          <v-icon @click="deleteEquipment(index)" :disabled="completed">mdi-delete</v-icon>
                        </td>
                        <td width="90%">
                          <multi-level-select :menuData="equipment(e.id)" :second.sync="e.id"/>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </outlined-block>
              </v-col>
            </v-row>

            <v-row v-if="type!=='sub'" dense>
              <v-col>
                <outlined-block  title="Inventory required">
                  <v-simple-table width="100%" class="mt-1">
                    <thead>
                      <tr>
                        <th width="10%" class="pa-0 text-center">
                          <v-btn fab color="primary" x-small @click="addMaterial()" :disabled="completed"><v-icon>mdi-plus</v-icon></v-btn>
                        </th>
                        <th width="60%">Material</th>
                        <th width="30%">Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(m,index) in materialsUsed" :key="m.id">
                        <td width="10%" class="pa-0 text-center">
                          <v-icon @click="deleteMaterial(index)" :disabled="completed">mdi-delete</v-icon>
                        </td>
                        <td width="60%">
                          <multi-level-select :menuData="materials(m.id)" :first.sync="m.type" :second.sync="m.id"/>
                        </td>
                        <td width="30%">
                          <decimal-number-input v-model="m.quantity" prefix="" :suffix="materialSuffix(m)" :precision="materialPrecision(m)" :outlined="false" class="text-body-2"/>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </outlined-block>
              </v-col>
            </v-row>
          </template>
        </v-container>

      </v-form>
    </div>
    <v-divider/>
    <v-card-actions>
      <v-spacer/>
      <v-btn @click="$emit('close')" plain>{{completed ? 'Done' : 'Cancel'}}</v-btn>
      <v-btn @click="type === 'template' ? saveFromTemplate() : save()" color="primary" v-if="!completed" :loading="loading">Save</v-btn>
    </v-card-actions>

    <v-dialog v-model="showMissingEquipment" persistent max-width="500">
      <v-card>
        <v-card-title>Missing equipment</v-card-title>
        <v-divider/>
        <v-card-text class="pa-4">
          This action requires the following equipment that has not been fully allocated:
          <ul class="my-4">
            <template v-for="equipmentType in requiredEquipment">
              <li>{{equipmentType.quantity===1?'':equipmentType.quantity+' x '}}{{equipmentTypeName(equipmentType.id)}}</li>
            </template>
          </ul>
          Are you sure you want to save this action?
        </v-card-text>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer/>
          <v-btn plain @click="showMissingEquipment=false;doSave()">Save</v-btn>
          <v-btn color="primary" @click="showMissingEquipment=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <planning-scheduling-roles-crupdate v-model="createRole" @create="roles.push($event);input.roleId=$event.id;assignTo.splice(0,assignTo.length)"/>
  </v-card>
</template>

<script>
import createHierarchyList from '@/mixins/createHierarchyList'
import PlanningSchedulingRolesCrupdate from '@/views/planning/scheduling/PlanningSchedulingRolesCrupdate'

export default {
  name: 'PlanningSchedulingActivity',
  mixins: [createHierarchyList],
  components: {PlanningSchedulingRolesCrupdate},
  props: {
    activity: {type:Object, required:false},
    action: {type:String, required:true},
    date: {type:String, required:false},
    toTemplate: {type:Boolean, required:false, default:false}
  },
  data() {
    return {
      valid: false,
      completed: false,
      loading: false,
      primitivesMenu: [],
      allEquipment: [],
      equipmentTypes: [],
      roles: [],
      equipmentUsed: [],
      materialsUsed: [],
      assignTo: [],
      input: {},
      type: '',
      categories: [],
      items: [],
      spirits: [],
      wines: [],
      allUsers: [],
      nonExcises: [],
      dependencies: [],
      showMissingEquipment: false,
      allTemplates: [],
      templateId: null,
      createRole: false
    }
  },
  computed: {
    sites() {
      return this.$store.getters.sites(true);
    },
    primitive() {
      if (!this.input.primitiveId)
        return null;
      for (const menu of this.primitivesMenu) {
        const primitive = menu.menu?.find(p => p.id === this.input.primitiveId);
        if (primitive)
          return primitive
      }
      return null;
    },
    requiredEquipment() {
      return this.primitive?.productionPlanningInfo?.equipmentTypes || [];
    },
    quantityLabel() {
      if (this.primitive?.name.startsWith('Mash') || this.primitive?.name.startsWith('Blend') || this.primitive?.name.startsWith('Distill'))
        return 'Volume to produce';
      if (this.primitive?.name.startsWith('Bottle'))
        return 'Quantity to bottle';
      if (this.primitive?.name.startsWith('Assemble'))
        return 'Qty to assemble';
    },
    quantitySuffix() {
      if (this.primitive?.name.startsWith('Mash'))
        return 'litres';
      if (this.primitive?.name.startsWith('Distill'))
        return 'LAA';
      if (this.primitive?.name.startsWith('Blend'))
        return this.primitive.blendToVolume ? 'litres' : this.primitive.producedUnits;
      if (this.primitive?.name.startsWith('Bottle'))
        return 'cases';
      if (this.primitive?.name.startsWith('Assemble'))
        return this.primitive.trackUnits;
    },
    quantityPrecision() {
      if (this.primitive?.name.startsWith('Mash') || this.primitive?.name.startsWith('Bottle'))
        return 0;
      if (this.primitive?.name.startsWith('Distill') || this.primitive?.name.startsWith('Blend'))
        return 3;
      if (this.primitive?.name.startsWith('Assemble'))
        return this.primitive.precision;
    },
    title() {
      let prefix = 'ad-hoc';
      if (this.input.hasSubActivities)
        prefix = 'group';
      else if (this.input.primitiveId)
        prefix = 'action';
      return `${this.completed ? `Completed ${prefix}` : `${this.action} ${this.action!=='Add'?`${prefix}`:''}`} ${this.input.parentId?'sub-':''}${this.input.template?'template':'activity'}${this.toTemplate?' to template':''}`;
    },
    templates() {
      return this.input.parentId ? this.allTemplates.filter(template => !template.hasSubActivities) : this.allTemplates;
    },
    selectedTemplate() {
      return this.allTemplates.find(template => template.id === this.templateId);
    }
  },
  watch: {
    activity: {
      handler() {
        const {endDate, subActivities, expanded, indent, completed, outstandingDependents, primitiveType, ...input} = this.activity;
        this.completed = this.action === 'Edit' && !!completed;
        this.input = input;
        if (this.action === 'Copy')
          delete this.input.id;
        if (this.input.hasSubActivities)
          this.type = 'sub';
        else if (this.input.primitiveId)
          this.type = "action";
        else
          this.type = "adhoc";
        let key = Date.now();
        this.equipmentUsed = this.input.equipment?.map(id => ({key:key++,id})) || [];
        this.materialsUsed = [];
        this.input.materials?.forEach(material => this.materialsUsed.push({...material}));
        this.assignTo = this.input.assignTo?.map(userId => ({id:userId,key:key++})) || [];
        this.templateId =  null;
        this.refreshDependencies();
        this.$nextTick(() => this.$refs.form.validate());
      },
      immediate: true,
      deep: true
    },
    date() {
      this.input.startDate = this.date;
    }
  },
  async created() {
    this.primitivesMenu = [{name:'Mash',id:'mash',menu:[]},{name:'Distill',id:'distill',menu:[]},{name:'Blend',id:'blend',menu:[]},{name:'Bottle',id:'bottle',menu:[]},{name:'Assemble',id:'assemble',menu:[]}];
    await Promise.all([
      this.$lazyListLoad(this.primitivesMenu[0].menu, 'mashBills2', 'id,name,volume,scalable,productionPlanningInfo {planningDuration,equipmentTypes{id,quantity},roleId}', 100, [{field:'active', comparator:'eq', value:'true'}]),
      this.$lazyListLoad(this.primitivesMenu[1].menu, 'processes2', 'id,name,productionPlanningInfo {planningDuration,equipmentTypes{id,quantity},roleId}', 100, [{field:'active', comparator:'eq', value:'true'}]),
      this.$lazyListLoad(this.primitivesMenu[2].menu, 'formulas2', 'id,name,scaleBase,scaleToId,producedUnits,blendToVolume ,productionPlanningInfo{planningDuration,equipmentTypes{id,quantity},roleId}', 100, [{field:'active', comparator:'eq', value:'true'}]),
      this.$lazyListLoad(this.primitivesMenu[3].menu, 'products2', 'id,name,caseSize,productionPlanningInfo {planningDuration,equipmentTypes{id,quantity},roleId}', 100, [{field:'active', comparator:'eq', value:'true'}]),
      this.$lazyListLoad(this.primitivesMenu[4].menu, 'items2', 'id,name,trackUnits,precision,category{id},productionPlanningInfo {planningDuration,equipmentTypes{id,quantity},roleId}', 100, [{field:'active', comparator:'eq', value:'true'},{field:'assembled',comparator:'eq',value:'true'}])
    ]);
    this.primitivesMenu[0].menu.forEach(m => m.name = `Mash ${m.name}`);
    this.primitivesMenu[1].menu.forEach(p => p.name = `Distill ${p.name}`);
    this.primitivesMenu[2].menu.forEach(f => f.name = `Blend ${f.name}`);
    this.primitivesMenu[3].menu.forEach(p => p.name = `Bottle ${p.name}`);
    this.primitivesMenu[4].menu.forEach(i => i.name = `Assemble ${i.name}`);
    this.$lazyListLoad(this.categories, 'categories2', 'id,name,parent{id}', 100, [], [{name:'type',value:'Item'}]);
    this.$lazyListLoad(this.spirits, 'spirits2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}]);
    this.$lazyListLoad(this.wines, 'wines2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}]);
    this.$lazyListLoad(this.nonExcises, 'nonExcises2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}]);
    this.$lazyListLoad(this.items, 'items2', 'id,name,trackUnits,precision,category{id},productionPlanningInfo {planningDuration,equipmentTypes{id,quantity},roleId}', 100, [{field:'active', comparator:'eq', value:'true'}]);
    this.$lazyListLoad(this.equipmentTypes, 'equipmentTypes2', 'id,name', 100, [], [{name:'includeDefault',value:'1'}]);

    const results = await this.$apiCall(`query PlanningSchedulingActivity {
                                           activityTemplates {
                                             id,description,primitiveId,hasSubActivities,startDate
                                           }
                                           roles {
                                             id,name,users
                                           }
                                           company {
                                             users {
                                               userId,name
                                             }
                                           }
                                          }`,
                                          {});
    if (!results.error) {
      this.allTemplates = results.data.activityTemplates;
//      if (results.data.mashBills.length)
//        this.primitivesMenu.push({name:'Mash',id:'mash',menu:[...results.data.mashBills.map(m => ({...m,name:`Mash ${m.name}`}))]});
//      if (results.data.processes.length)
//        this.primitivesMenu.push({name:'Distill',id:'distill',menu:[...results.data.processes.map(m => ({...m,name:`Distill ${m.name}`}))]});
//      if (results.data.formulas.length)
//        this.primitivesMenu.push({name:'Blend',id:'blend',menu:[...results.data.formulas.map(m => ({...m,name:`Blend ${m.name}`}))]});
//      if (results.data.products.length)
//        this.primitivesMenu.push({name:'Bottle',id:'bottle',menu:[...results.data.products.map(m => ({...m,name:`Bottle ${m.name}`}))]});
//      const assembledItems = results.data.items.filter(item => item.assembled);
//      if (assembledItems.length)
//        this.primitivesMenu.push({name:'Assemble',id:'assemble',menu:[...assembledItems.map(m => ({...m,name:`Assemble ${m.name}`}))]});

      const fermenters = [];
      const tanks = [];
      const stills = [];
      const otherEquipment = [];
      await Promise.all([
        this.$lazyListLoad(fermenters, 'fermenters2', 'id,name,equipmentType{id},site{id}', 100, [{field:'active', comparator:'eq', value:'true'}]),
        this.$lazyListLoad(tanks, 'tanks2', 'id,name,equipmentType{id},site{id}', 100, [{field:'active', comparator:'eq', value:'true'}]),
        this.$lazyListLoad(stills, 'stills2', 'id,name,equipmentType{id},site{id}', 100, [{field:'active', comparator:'eq', value:'true'}]),
        this.$lazyListLoad(otherEquipment, 'otherEquipments2', 'id,name,equipmentType{id},site{id}', 100, [{field:'active', comparator:'eq', value:'true'}]),
      ]);
      this.allEquipment = [...tanks, ...fermenters,...stills,...otherEquipment];

//      this.nonExcises = results.data.nonExcises;
//      this.items = results.data.items;
      this.roles = [{name:'(none specified)',id:''},{divider:true},...results.data.roles];
      this.allUsers = results.data.company.users;
    }
  },
  methods: {
    addAssignTo() {
      this.assignTo.push({id:'',key:Date.now()});
      this.$nextTick(() => this.$refs.form.validate());
    },
    users(allowUserId) {
      let users = this.allUsers;
      if (this.input.roleId)
        users = this.roles.find(role => role.id === this.input.roleId).users.map(user => this.allUsers.find(u => u.userId === user));

      // Remove user id if already used, except for explictly allowed userId
      return users.filter(user => user.userId === allowUserId || !this.assignTo.some(u => u.id === user.userId));
    },
    equipment(currentId) {
      const equipment = [];

      // Remove used equipment from eligbile equipment
      const allEquipment = this.allEquipment.filter(equipment => (this.input.template || this.toTemplate || equipment.site.id === this.input.siteId) &&
                                                                 (equipment.id === currentId || !this.equipmentUsed.some(e => e.id === equipment.id)));
      for (const type of this.equipmentTypes) {
        const menu = allEquipment.filter(equipment => equipment.equipmentType?.id === type.id);
        if (menu.length)
          equipment.push({name:type.name, id:type.id, menu});
      }
      const menu = allEquipment.filter(equipment => !equipment.equipmentType?.id);   // "Other" equipment
      if (menu.length)
        equipment.push({name:"Other", id:'', menu});

      return equipment;
    },
    addEquipment() {
      this.equipmentUsed.push({key:Date.now(),id:''});
      this.$nextTick(() => this.$refs.form.validate());
    },
    deleteEquipment(index) {
      this.equipmentUsed.splice(index, 1);
    },
    materials(currentId) {
      const materials = [];
      if (this.spirits.length)
        materials.push({name:'Spirit',id:'Spirit',menu:this.spirits});
      if (this.wines.length)
        materials.push({name:'Wine',id:'Wine',menu:this.wines});
      if (this.nonExcises.length)
        materials.push({name:'Non-excise',id:'NonExcise',menu:this.nonExcises});
      if (this.items.length) {
        if (this.categories.length) {
          const categories = this.createHierarchyList(this.categories);
          for (const category of categories) {
            const sub = this.items.filter(item => item.category?.id === category.id);
            if (sub.length)
              category.menu = sub;
            else
              category.disabled = true;
          }
//          materials.push({name:'Item',id:'Item',menu:[...categories.filter(category => !category.disabled)]});
          materials.push({name:'Item',id:'Item',menu:categories});
          const leftOver = this.items.filter(item => !item.category?.id);
          if (leftOver.length)
            materials[materials.length-1].menu.push({divider:true},{name:'Other items',id:'x',menu:leftOver});
        }
        else
          materials.push({name:'Item',id:'Item',menu:this.items});
      }
      return materials;
    },
    addMaterial() {
      this.materialsUsed.push({type:'',id:'',quantity:0});
      this.$nextTick(() => this.$refs.form.validate());
    },
    deleteMaterial(index) {
      this.materialsUsed.splice(index, 1);
    },
    materialPrecision(material) {
      if (material.type === 'Item')
        return this.items.find(item => item.id === material.id)?.precision || 0;
      return 3;
    },
    materialSuffix(material) {
      if (material.type === 'Item')
        return this.items.find(item => item.id === material.id)?.trackUnits;
      if (material.type === 'Spirit')
        return 'LAA';
      return 'litres';
    },
    equipmentTypeName(typeId) {
      return this.equipmentTypes.find(t => t.id === typeId)?.name;
    },
    async refreshDependencies() {
      if (!this.input.startDate)
        return;
      const results = await this.$apiCall(`query PlanningSchedulingActivity($date:Date!, $excludeId:ID!, $parentId:ID!, $offsetDays:Int!) {
                                              activitiesEndingOnOrBefore(date:$date,excludeId:$excludeId,parentId:$parentId,offsetDays:$offsetDays) {
                                                id,description
                                              }
                                            }`,
                                            {date:this.input.startDate, excludeId:this.input.id || '',
                                             parentId:this.input.parentId || '', offsetDays:this.input.parentId?this.input.offsetDays : 0});
      if (!results.error)
        this.dependencies = results.data.activitiesEndingOnOrBefore;
    },
    changePrimitive() {
      this.input.description = this.primitive?.name;

      if (this.primitive?.name.startsWith('Mash'))
        this.input.quantity = this.primitive.volume;

      else if (this.primitive?.name.startsWith('Distill'))
        this.input.quantity = 0;

      else if (this.primitive?.name.startsWith('Blend'))
        this.input.quantity = this.primitive.scaleBase;

      else if (this.primitive?.name.startsWith('Bottle'))
        this.input.quantity = 0;
      else if (this.primitive?.name.startsWith('Assemble'))
        this.input.quantity = 0;

      this.setPrimitiveMaterials();
      this.setDuration();
      this.input.roleId = this.primitive?.productionPlanningInfo.roleId;
    },
    setDuration() {
      const quantity = this.primitive?.name.startsWith('Bottle') || this.primitive?.name.startsWith('Assemble') ? this.input.quantity : 1;
      this.input.duration = quantity * (this.primitive?.productionPlanningInfo?.planningDuration ?? 0);
    },
    async setPrimitiveMaterials() {
      this.materialsUsed = [];

      if (this.primitive?.name.startsWith('Mash')) {
        if (!this.primitive.items) {
          const results = await this.$apiCall(`query PlanningSchedulingActivity($id:ID!) {
                                                  mashBill(id:$id) {
                                                    items {itemId,quantity}
                                                  }
                                                }`,
                                                {id:this.primitive.id});
          if (!results.error)
            this.primitive.items = results.data.mashBill.items;
        }
        for (const item of this.primitive.items || []) {
          const material = {type:'Item',id:item.itemId};
          if (this.primitive.scalable)
            material.quantity = this.$roundNumber(item.quantity * this.input.quantity / this.primitive.volume, this.materialPrecision(material));
          else
            material.quantity = item.quantity;
          this.materialsUsed.push(material);
        }
      }

      else if (this.primitive?.name.startsWith('Distill')) {
        if (!this.primitive.inputs) {
          const results = await this.$apiCall(`query PlanningSchedulingActivity($id:ID!) {
                                                  process(id:$id) {
                                                    inputs {type,id,quantity}
                                                  }
                                                }`,
                                                {id:this.primitive.id});
          if (!results.error)
            this.primitive.inputs = results.data.process.inputs;
        }
        for (const input of this.primitive.inputs || []) {
          if (input.type === 'Mash')
            continue;
          this.materialsUsed.push(input);
        }
      }

      else if (this.primitive?.name.startsWith('Blend')) {
        if (!this.primitive.inputs) {
          const results = await this.$apiCall(`query PlanningSchedulingActivity($id:ID!) {
                                                  formula(id:$id) {
                                                    inputs {type,id,quantity}
                                                  }
                                                }`,
                                                {id:this.primitive.id});
          if (!results.error)
            this.primitive.inputs = results.data.formula.inputs;
        }

        let scaleFactor = 1;
        for (const input of this.primitive.inputs || []) {
          let quantity;
          if (input.type === 'Spirit' || input.type === 'Wine') {
            quantity = this.$roundNumber(this.input.quantity * input.quantity / 100, 3);
            if (input.id === this.primitive.scaleToId)
              scaleFactor = quantity / this.primitive.scaleBase;
          }
          else
            quantity = input.quantity;
          this.materialsUsed.push({type:input.type,id:input.id,quantity});
        }
        for (const material of this.materialsUsed)
          if (material.type !== 'Spirit' && material.type !== 'Wine')
            material.quantity = this.$roundNumber(material.quantity * scaleFactor, this.materialPrecision(material));
      }

      else if (this.primitive?.name.startsWith('Bottle')) {
        if (!this.primitive.bom) {
          const results = await this.$apiCall(`query PlanningSchedulingActivity($id:ID!) {
                                                  product(id:$id) {
                                                    bom {type,id,quantity,per}
                                                  }
                                                }`,
                                                {id:this.primitive.id});
          if (!results.error)
            this.primitive.bom = results.data.product.bom;
        }
        for (const material of this.primitive.bom || []) {
          let quantity = material.quantity;
          if (material.per === 'Bottle')
            quantity *= this.input.quantity * this.primitive.caseSize;
          else if (material.per === 'Case')
            quantity *= this.input.quantity;
          this.materialsUsed.push({type:material.type,id:material.id,quantity});
        }
      }

      else if (this.primitive?.name.startsWith('Assemble')) {
        if (!this.primitive.bom) {
          const results = await this.$apiCall(`query PlanningSchedulingActivity($id:ID!) {
                                                  item(id:$id) {
                                                    bom {id,quantity}
                                                  }
                                                }`,
                                                {id:this.primitive.id});
          if (!results.error)
            this.primitive.bom = results.data.item.bom;
        }
        for (const material of this.primitive.bom || [])
          this.materialsUsed.push({type:'Item',id:material.id,
                                     quantity:this.$roundNumber(material.quantity * this.input.quantity, this.materialPrecision(material))});
      }
    },
    async save() {
      if (!this.valid) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }      // Check each required equipment for the selected primitive
      for (const equipmentType of this.requiredEquipment) {

        // Check each activity equipment to see if activity has this equipment type?
        const used = this.equipmentUsed.reduce((count, activityEquipment) => {
          const typeId = this.equipment(activityEquipment.id).find(type => type.menu.find(e => e.id === activityEquipment.id))?.id;
          return count + (typeId === equipmentType.id ? 1: 0);
        }, 0);

        if (used !== equipmentType.quantity) {
          this.showMissingEquipment = true;
          return;
        }
      }
      this.doSave();
    },
    async doSave() {
      this.loading = true;
      this.input.hasSubActivities = this.type === 'sub';
      this.input.equipment = this.equipmentUsed.map(equipment => equipment.id);
      this.input.materials = this.materialsUsed;
      this.input.assignTo = this.assignTo.map(assignTo => assignTo.id);
      this.input.template = this.toTemplate;
      const results = await this.$apiCall(`mutation PlanningSchedulingActivity($input:ActivityInput!, $create:Boolean!) {
                                             activityCreate(input:$input) @include(if:$create) {
                                               id
                                             }
                                             activityUpdate(input:$input) @skip(if:$create) {
                                               id
                                             }
                                           }`,
                                           {input:this.input, create:this.action === 'Add' || this.action === 'Copy'});
      if (!results.error) {
        if (this.activity.hasSubActivities && this.action === 'Copy') {
          const parentId = results.data.activityCreate.id;
          const newDependsOn = new Map();
          for (const subActivity of this.activity.subActivities) {
            const {id, endDate, subActivities, expanded, indent, completed, outstandingDependents, primitiveType, ...input} = subActivity;
            input.parentId = parentId;
            input.template = this.toTemplate;

            // Depends on needs to refer to newly copied activities, not original
            for (let i = 0; i < input.dependsOn.length; i++)
              input.dependsOn[i] = newDependsOn.get(input.dependsOn[i]);

            const results2 = await this.$apiCall(`mutation PlanningSchedulingActivity($input:ActivityInput!) {
                                                    activityCreate(input:$input) {
                                                      id
                                                    }
                                                  }`,
                                                  {input});
            newDependsOn.set(id, results2.data.activityCreate.id);
          }
        }
        this.$emit('refresh');
      }
      this.loading = false;
    },
    async saveFromTemplate() {
      if (!this.valid) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }      // Get full template
      this.loading = true;
      let results = await this.$apiCall(`query PlanningSchedulingActivity($id:ID!) {
                                              activity(id:$id) {
                                                ...activityFields
                                                subActivities {
                                                  ...activityFields
                                                }
                                              }
                                            }
                                            fragment activityFields on Activity {
                                              id,description,startDate,duration,color,quantity,primitiveId,siteId
                                              dependsOn,
                                              hasSubActivities,parentId,offsetDays,equipment
                                              materials {type,id,quantity}
                                              roleId,assignTo
                                            }`,
                                          {id:this.templateId});
      this.loading = false;
      if (results.error)
        return;
      this.loading = true;

      const subActivities = results.data.activity.subActivities;
      delete results.data.activity.subActivities;
      delete results.data.activity.id;
      const input = Object.assign(results.data.activity, {siteId:this.input.siteId,startDate:this.input.startDate,
                                                          offsetDays:this.input.offsetDays,dependsOn:this.input.dependsOn,
                                                          parentId:this.input.parentId,
                                                          description:this.input.description});

      results = await this.$apiCall(`mutation PlanningSchedulingActivity($input:ActivityInput!) {
                                             activityCreate(input:$input) {
                                               id
                                             }
                                           }`,
                                           {input});
      if (!results.error) {
        if (input.hasSubActivities) {
          const parentId = results.data.activityCreate.id;
          const newDependsOn = new Map();
          for (const subActivity of subActivities) {
            const {id, endDate, subActivities, expanded, indent, completed, outstandingDependents, ...input2} = subActivity;
            input2.parentId = parentId;
            input2.siteId = this.input.siteId;

            // Depends on needs to refer to newly copied activities, not original
            for (let i = 0; i < input2.dependsOn.length; i++)
              input2.dependsOn[i] = newDependsOn.get(input2.dependsOn[i]);

            const results2 = await this.$apiCall(`mutation PlanningSchedulingActivity($input:ActivityInput!) {
                                                    activityCreate(input:$input) {
                                                      id
                                                    }
                                                  }`,
                                                  {input:input2});
            newDependsOn.set(id, results2.data.activityCreate.id);
          }
        }
        this.$emit('refresh');
      }
      this.loading = false;
    }
  }
}
</script>